import React, { useEffect, useState } from 'react'
import router from 'next/router'
import { omit, size } from 'lodash'
import { connect } from 'react-redux'
import { isEmpty, isEmail } from 'validator'

import Meta from '@/components/common/Meta'
import { RegisterSrOnly } from '@/v1/sr-only'
import { META_CONTENTS } from '@/v1/constants/seo'
import Promotion from '@/components/sections/Promotion'
import RegForm from '@/components/subComponents/auth/regForm'
import * as actionTypes from '@/store/constants/actionTypes'

function Register(props) {
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    country_id: '',
    state_id: '',
    accept: ''
  })

  useEffect(() => {
    if (props.Auth_Reducer.auth) {
      router.replace('/book-storage-facility').then()
    }
  }, [props.Auth_Reducer])

  useEffect(() => {
    async function propsLoading() {
      // set page banner type
      await props.onSetHeaderType('without-banner')
      // set page banner
      await props.onSetBanner(false)
      // set countries if empty countries
      if (props.Order_Reducer.countries === false) {
        props.onGetCountries()
      }
    }

    propsLoading().then()
  }, [])

  const errorsProps = props?.Auth_Reducer?.errors?.errors || {}

  // console.log({ errorsProps })

  useEffect(() => {
    if (Object.keys(errorsProps).length) {
      setErrors(errorsProps)
      setLoading(false)
    }
  }, [errorsProps])

  const setCountry = async country => {
    setErrors(omit(errors, 'country_id'))
    setFormData({
      ...formData,
      country_id: country.country_id
    })
    if (country.country_id === 226) {
      await props.onGetStates({ country: country.country_id })
    }
  }

  const setCountryState = state => {
    setErrors(omit(errors, 'state_id'))
    setFormData({
      ...formData,
      state_id: state.state_id
    })
  }

  const inputOnChangeHandler = e => {
    const name = e.target.name
    let value = e.target.value

    // console.log({name, value})

    if (e.target.type === 'checkbox') {
      value = e.target.checked
      setFormData({
        ...formData,
        [name]: Number(value)
      })
    } else {
      setFormData({
        ...formData,
        [name]: value
      })
    }
  }

  const formValidation = () => {
    let newErrors = {}
    setErrors(newErrors)
    let spPattern = /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#]/

    if (isEmpty(formData.first_name)) {
      newErrors.first_name = ['First name is required']
    } else if (spPattern.test(formData.first_name)) {
      newErrors.first_name = ['Invalid first name format']
    }

    if (isEmpty(formData.last_name)) {
      newErrors.last_name = ['Last name is required']
    } else if (spPattern.test(formData.last_name)) {
      newErrors.last_name = ['Invalid last name format']
    }

    if (isEmpty(formData.email)) {
      newErrors.email = ['Email is required']
    } else if (!isEmail(formData.email)) {
      newErrors.email = ['Invalid email format']
    }

    if (isEmpty(formData.password)) {
      newErrors.password = ['Password is required']
    }

    if (isEmpty(String(formData.country_id))) {
      newErrors.country_id = ['Country is required']
    }

    if (formData.country_id === 226) {
      if (isEmpty(String(formData.state_id))) {
        newErrors.state_id = ['State is required']
      }
    }

    if (isEmpty(String(formData.accept))) {
      newErrors.accept = ['Please accept Terms & Condition']
    }

    if (size(newErrors) > 0) {
      setErrors(newErrors)
    } else {
      return true
    }

    return false
  }

  const formOnSubmitHandler = async e => {
    e.preventDefault()
    let validate = formValidation()
    if (validate === true) {
      setLoading(true)
      await props.onRegister({
        ...formData,
        password_confirmation: formData.password
      })
    }
  }

  return (
    <>
      <Meta
        title={META_CONTENTS.register.title}
        keywords={META_CONTENTS.register.keywords}
        description={META_CONTENTS.register.description}
        noIndex
        noFollow
      />

      <RegisterSrOnly />

      <section className='login-section pt-24 pb-14 md-mx:pt-12 sm-mx:pt-10'>
        <div className='container'>
          <div className={'max-1170'}>
            <RegForm
              countries={props.Order_Reducer.countries}
              states={props.Order_Reducer.statesData}
              setCountry={setCountry}
              setCountryState={setCountryState}
              formData={formData}
              setFormData={setFormData}
              showError={props.Auth_Reducer.setError}
              formErrors={errors}
              inputOnChangeHandler={inputOnChangeHandler}
              formOnSubmitHandler={formOnSubmitHandler}
              loading={loading}
            />
          </div>
        </div>
      </section>
      <Promotion />
    </>
  )
}

const mapStateToProps = state => {
  return {
    Order_Reducer: state.orderReducer,
    Auth_Reducer: state.authReducer
  }
}
const mapDispatchToProps = dispatch => ({
  onSetBanner: banner => dispatch({ type: actionTypes.SET_PAGE_BANNER, data: banner }),
  onSetHeaderType: headerType => dispatch({ type: actionTypes.SET_HEADER_TYPE, data: headerType }),
  onGetCountries: () => dispatch({ type: actionTypes.FETCH_COUNTRIES }),
  onGetStates: data => dispatch({ type: actionTypes.FETCH_STATES, creds: data }),
  onRegister: data => dispatch({ type: actionTypes.USER_REGISTER, creds: data })
})
export default connect(mapStateToProps, mapDispatchToProps)(Register)
